import React from 'react';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import { DynamicFormWarningProps } from './types';

/**
 * Dynamic form warning component for displaying warning messages with icon
 * 
 * @param header - Warning configuration object containing label and optional description
 * @returns JSX element for the warning display with styled container and icon
 */
const DynamicFormWarning: React.FC<DynamicFormWarningProps> = (header) => {
  return (
    <div className="flex gap-2 rounded-lg border border-warning-subtle bg-warning-primary-hover p-6">
      <HiOutlineExclamationTriangle className="size-6 shrink-0 text-warning" />
      <div className="flex flex-col gap-1.5">
        <h3 className="font-semibold text-warning">{header.label}</h3>
        {header.description && <p className="text-sm text-warning">{header.description}</p>}
      </div>
    </div>
  );
};

export default DynamicFormWarning;